import { isUserEntryNumeric } from '@ebiz/pretty-num/';

////////////////////////////////////////////////////////////////////////////////////
// validation - Class containing function for character and field validation      //
////////////////////////////////////////////////////////////////////////////////////

export default {
  ////////////////////////////////////////////////////////////////////////////////
  // Functions                                                                  //
  ////////////////////////////////////////////////////////////////////////////////

  // Function for Character Validation
  // Inputs: value - value to be validated
  //         type - value field type
  //         scope - used for custom validation, usually contains a Regular Expression, otherwise null
  // Returns: result - true when valid
  validateCharacterInput: function (value: string, type: string, scope?: RegExp): boolean {
    return this.validateFieldInput(value, type, scope);
  },

  // Function for Field Validation
  // Inputs: value - value to be validated
  //         type - value field type
  //         scope - used for custom validation, usually contains a Regular Expression, otherwise null
  // Returns: result - true when valid
  validateFieldInput: function (value: string, type: string, scope?: RegExp): boolean {
    let result = true;
    let pattern = /^/;
    switch (type) {
      case 'ALPHANUMERIC':
        pattern = /^[0-9a-zA-Z]+$/;
        result = pattern.test(value.toString());
        break;
      case 'ALPHABET':
        pattern = /^[a-zA-Z]+$/;
        result = pattern.test(value.toString());
        break;
      case 'NUMERIC':
      case 'NUMERICDECIMAL':
      case 'ENGINEERING': {
        result = isUserEntryNumeric(value.toString());
        break;
      }
      case 'CUSTOM':
        if (scope) {
          pattern = scope;
          result = pattern.test(value.toString());
        }
        break;
      case 'ALLCHARS':
      default:
        break;
    }
    return result;
  },
};
